import { InlineDossier } from './InlineDossier';
import { DecisionTrace } from './DecisionTrace';

interface CommandCenterProps {
  analysis: Record<string, unknown> | null;
  strategy: Record<string, unknown> | null;
  decisionTrace: Record<string, unknown> | null;
}

export const CommandCenter = ({
  analysis,
  strategy,
  decisionTrace,
}: CommandCenterProps): JSX.Element => {
  return (
    <div className="space-y-3">
      <InlineDossier analysis={analysis} strategy={strategy} />
      <DecisionTrace trace={decisionTrace} />
    </div>
  );
};
